// extracted by css-extract-rspack-plugin
export default {"cls1":"MobileChipize-cls1_07o","cls2":"MobileChipize-cls2_iBY MobileChipize-cls1_07o"};